import { render, staticRenderFns } from "./_Basic.vue?vue&type=template&id=3c8b2fb3&scoped=true&"
import script from "./_Basic.vue?vue&type=script&lang=js&"
export * from "./_Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b2fb3",
  null
  
)

export default component.exports